// extracted by mini-css-extract-plugin
module.exports = {"grid":"style_grid__2YR7I","column":"style_column__Du6wj","row":"style_row__2fCcm"};